import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';

import { Trial } from 'entities/tariff/api/contracts';
import { getDatePlusDaysPeriod } from 'shared/lib/getDatePlusDaysPeriod';
import {
	ChooseUnitsSummaryPriceStyled,
	PeriodStyled,
	PriceContainerStyled,
	PriceStyled,
	SpecialPriceStyled,
} from './SubscribePrice.styles';

interface ApplicationPlanModalPriceProps {
	price: number;
	loading: boolean;
	hasSpecialPrice: boolean;
	isTrialAvailable: boolean;
	trial: Trial | null;
}

export const SubscribePrice: FC<ApplicationPlanModalPriceProps> = ({
	price,
	loading,
	hasSpecialPrice,
	trial,
	isTrialAvailable,
}) => {
	const { t } = useTranslation();
	if (loading) {
		return (
			<PriceStyled>
				<Spin />
			</PriceStyled>
		);
	}

	return (
		<PriceContainerStyled>
			<PriceStyled>
				<ChooseUnitsSummaryPriceStyled data-testid='price-field'>{`${price.toLocaleString()} ₽${
					hasSpecialPrice ? `*` : ``
				}`}</ChooseUnitsSummaryPriceStyled>
				<PeriodStyled>{`/${t(`Marketplace_Per_Month`)}`}</PeriodStyled>
			</PriceStyled>
			{hasSpecialPrice && <SpecialPriceStyled>*Персональная цена для вашей сети</SpecialPriceStyled>}
			{trial && isTrialAvailable && (
				<SpecialPriceStyled style={{ color: `#FAAD14` }}>
					{t(`Marketplace_Starting_From`, { date: getDatePlusDaysPeriod(trial.duration) })}
				</SpecialPriceStyled>
			)}
		</PriceContainerStyled>
	);
};
